import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AsconActions} from '../../../pages/team/view-team/view-team.component';
import {setUserActions} from '../../../pages/user-actions.service';
import {NbMenuService, NbSidebarService} from '@nebular/theme';
import {getLoggedUser} from "../../../store/users/users.selectors";
import {Store} from "@ngrx/store";
import {IAppState} from "../../../store/app.state";
import {combineLatest, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";


@Component({
  selector: 'ngx-ascon-sidebar',
  styleUrls: ['./ascon-sidebar.component.scss'],
  templateUrl: './ascon-sidebar.component.html'
})
export class AsconSidebarComponent implements OnInit, OnDestroy {

  public user: any;
  public menu = [];
  public originalMenu = [];
  public searchText: string = '';
  public isSidebarExtended = true;
  public subject = new Subject();

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerWidth = window.innerWidth;
    if (innerWidth < 580) {
      this.sidebarService.compact('menu-sidebar');
    }
  }

  constructor(
    private menuService: NbMenuService,
    private sidebarService: NbSidebarService,
    private store: Store<IAppState>,
  ) {
  }

  ngOnInit() {
    this.getUser();

    this.menuService.onItemClick().subscribe(() => {
      this.resetMenu();
      this.sidebarService.compact('menu-sidebar');
    });

    this.sidebarService.onCompact()
      .subscribe(obs => {
        this.isSidebarExtended = false;
        this.resetMenu();
      });

    this.sidebarService.onExpand()
      .subscribe(obs => {
        this.isSidebarExtended = true;
        this.resetMenu();
      });

    this.sidebarService.onCollapse()
      .subscribe(obs => {
        this.isSidebarExtended = false;
        this.resetMenu();
      });

    this.sidebarService.onToggle()
      .subscribe(obs => {
        this.isSidebarExtended = !this.isSidebarExtended;
        this.resetMenu();
      });
  }

  ngOnDestroy() {
    this.subject.next();
  }

  resetMenu() {
    this.searchText = '';
    this.menu = this.originalMenu;
  }

  getUser() {
    combineLatest([
      this.store.select(getLoggedUser)
    ])
      .pipe(takeUntil(this.subject))
      .subscribe(([user]: [any]) => {
        if (!user?.user_id) return;
        setUserActions(user?.actions);
        this.originalMenu = [
          {
            title: 'ASCON',
            group: true,
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewAsconDashboard
            )
          },
          {
            title: 'Dashboard',
            icon: 'layout-outline',
            link: '/pages/ascon-dashboard',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewAsconDashboard
            )
          },
          {
            title: 'CLIENTI',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.Clients_ViewAllClients ||
                action.action_id == AsconActions.Clients_ViewTeamClients ||
                action.action_id == AsconActions.Clients_ViewMyClients
            )
          },
          {
            title: 'Lista clienti',
            icon: 'shopping-cart-outline',
            link: '/pages/clients/view-clients',
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.Clients_ViewAllClients ||
                action.action_id == AsconActions.Clients_ViewTeamClients ||
                action.action_id == AsconActions.Clients_ViewMyClients
            )
          },
          {
            title: 'Indicatori clienti',
            icon: 'trending-up-outline',
            link: '/pages/clients/view-clients-indicators',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewClientsIndicators
            )
          },
          {
            title: 'Fise de lucru',
            icon: 'file-add-outline',
            link: '/pages/worksheets/view-worksheets',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewWorksheets
            )
          },
          {
            title: 'Raport Fise de lucru',
            icon: 'checkmark-square-outline',
            link: '/pages/worksheets/worksheets-report',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewWorksheetReport
            )
          },
          {
            title: 'Contracte clienti',
            icon: 'archive-outline',
            link: '/pages/clients/view-clients-contracts',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewClientContracts
            )
          },
          {
            title: 'MANAGEMENT',
            group: true,
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewManagementReport
            )
          },
          {
            title: 'Status TVA',
            icon: 'person-done-outline',
            link: '/pages/management/view-vat-status',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewVatStatus
            )
          },
          {
            title: 'Raport de management',
            icon: 'person-done-outline',
            link: '/pages/management/view-management-report',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewManagementReport
            )
          },
          {
            title: 'Fișa de conturi',
            icon: 'layout-outline',
            link: '/pages/management/view-account-records',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.CanViewAccountRecords
            )
          },
          {
            title: 'Restanțe clienți',
            icon: 'alert-triangle-outline',
            link: '/pages/management/view-unpaid-invoices',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.CanViewUnpaidInvoices
            )
          },
          {
            title: 'Import statement bancar',
            icon: 'alert-triangle-outline',
            link: '/pages/management/import-bank-statement',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ImportBankStatements
            )
          },
          {
            title: 'Notificări email',
            icon: 'bell-outline',
            link: '/pages/management/view-email-notifications',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.CanViewEmailNotifications
            )
          },
          {
            title: 'Verificari admin',
            icon: 'eye-outline',
            link: '/pages/worksheets/admin-verification',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewAdminVerification
            )
          },
          {
            title: 'Stadiu lucrări',
            icon: 'checkmark-square-outline',
            link: '/pages/management/work-status',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewWorkStatus
            )
          },
          {
            title: 'Statistici tichete',
            icon: 'pie-chart-outline',
            link: '/pages/tichet-stats',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewTichetStats
            )
          },
          {
            title: 'EVIDENTA TIMP DE LUCRU',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.Clients_ViewAllClients ||
                action.action_id == AsconActions.Clients_ViewTeamClients ||
                action.action_id == AsconActions.Clients_ViewMyClients
            )
          },
          {
            title: 'Adauga raport zilnic de lucru',
            icon: 'folder-add-outline',
            link: '/pages/daily-logs/add-daily-log',
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.Clients_ViewAllClients ||
                action.action_id == AsconActions.Clients_ViewTeamClients ||
                action.action_id == AsconActions.Clients_ViewMyClients
            )
          },
          {
            title: 'Raport ore de lucru',
            icon: 'layout-outline',
            link: '/pages/dashboard/view-dashboard',
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.Clients_ViewAllClients ||
                action.action_id == AsconActions.Clients_ViewTeamClients ||
                action.action_id == AsconActions.Clients_ViewMyClients
            )
          },
          {
            title: 'Concedii',
            icon: 'calendar-outline',
            link: '/pages/holidays/add-holiday',
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.Clients_ViewAllClients ||
                action.action_id == AsconActions.Clients_ViewTeamClients ||
                action.action_id == AsconActions.Clients_ViewMyClients
            )
          },
          {
            title: 'DEPARTAMENT PERSONAL',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewHrLedger ||
                action.action_id == AsconActions.ViewWorksheetsHr ||
                action.action_id == AsconActions.ViewEmployees
            )
          },
          {
            title: 'Evidenta HR',
            icon: 'book-open-outline',
            link: '/pages/hr/view-registration-numbers',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewHrLedger
            )
          },
          {
            title: 'Fise de lucru HR',
            icon: 'book-open-outline',
            link: '/pages/worksheets/view-worksheets-hr',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewWorksheetsHr
            )
          },
          {
            title: 'Angajati',
            icon: 'pricetags-outline',
            link: '/pages/hr/view-employees',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewEmployees
            )
          },
          {
            title: 'Stat de plata',
            icon: 'file-text-outline',
            link: '/pages/hr/view-payroll',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewAllClientsPayrolls ||
                action.action_id == AsconActions.ViewMyClientsPayrolls ||
                action.action_id == AsconActions.ViewTeamClientsPayrolls
            )
          },
          {
            title: 'SECRETARIAT',
            group: true,
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewHrNumbers
            )
          },
          {
            title: 'Numere de ordine',
            icon: 'book-open-outline',
            link: '/pages/hr/view-order-numbers',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewHrNumbers
            )
          },
          {
            title: 'FINANCIAR',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewPayments ||
                action.action_id == AsconActions.ViewIncomes ||
                action.action_id == AsconActions.ViewSagaIncomes
            )
          },
          {
            title: 'Rentabilitate',
            icon: 'activity-outline',
            link: '/pages/clients/rentability',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewRentability
            )
          },
          {
            title: 'Registru incasari plati',
            icon: 'shopping-bag-outline',
            link: '/pages/payments/view-incomes2',
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewPayments ||
                action.action_id == AsconActions.ViewIncomes ||
                action.action_id == AsconActions.ViewSold
            )
          },
          {
            title: 'Raport financiar',
            icon: 'shopping-bag-outline',
            link: '/pages/payments/financial-report',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.FinancialReport
            )
          },
          {
            title: 'Raport financiar pe grupe',
            icon: 'shopping-bag-outline',
            link: '/pages/payments/financial-report-computed',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.FinancialReport
            )
          },
          {
            title: 'Solduri clienti',
            icon: 'npm-outline',
            link: '/pages/incomes/view-incomes-saga',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewSagaIncomes
            )
          },
          {
            title: 'Tarife/oferte',
            icon: 'shopping-bag-outline',
            link: '/pages/payments/tarifs',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.Tarifs
            )
          },
          {
            title: 'Facturi',
            icon: 'shopping-bag-outline',
            link: '/pages/invoices/invoices',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewInvoices
            )
          },
          {
            title: 'Facturi companii',
            icon: 'shopping-bag-outline',
            link: '/pages/company-invoices/company-invoices',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewCompanyInvoices
            )
          },
          {
            title: 'Calculator grila',
            icon: 'shopping-bag-outline',
            link: '/pages/payments/calculator',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewCalculator
            )
          },
          {
            title: 'SALARII',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewAsconSalaries ||
                action.action_id == AsconActions.UserPortofolio
            )
          },
          {
            title: 'Calculator salarii nou',
            icon: 'alert-triangle-outline',
            link: '/pages/salaries/view-ascon-salaries-new',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewAsconSalaries
            )
          },
          {
            title: 'Rentabilitate portofoliu',
            icon: 'trending-up-outline',
            link: '/pages/salaries/view-rentabilitate-portofoliu',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewAsconSalaries // CHANGE PERMISSION MAYBE?
            )
          },
          {
            title: 'Calculator tichete',
            icon: 'book-open-outline',
            link: '/pages/salaries/view-ascon-tickets',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewAsconTicheteWidgets
            )
          },
          {
            title: 'IT',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewSupportTickets
            )
          },
          {
            title: 'Taskuri IT',
            icon: 'archive-outline',
            link: '/pages/support/view-support',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewSupportTickets
            )
          },
          {
            title: 'Raport Taskuri IT',
            icon: 'bar-chart-outline',
            link: '/pages/support/view-report',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewSupportTickets
            )
          },
          {
            title: 'Ghiduri',
            icon: 'book-outline',
            link: '/pages/support/view-ghiduri-admin',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewSupportTickets
            )
          },
          {
            title: 'STRUCTURA',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.UserPortofolio ||
                action.action_id == AsconActions.ViewTeams ||
                action.action_id == AsconActions.ViewUsers
            )
          },
          {
            title: 'Utilizatori',
            icon: 'person-outline',
            link: '/pages/team/view-users',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewUsers
            )
          },
          {
            title: 'Echipa',
            icon: 'people-outline',
            link: '/pages/team/view-team',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewTeams
            )
          },
          {
            title: 'Portofoliu echipa',
            icon: 'archive-outline',
            link: '/pages/clients/clients-portofolio',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.UserPortofolio
            )
          },
          // {
          //   title: 'Portofoliu nou echipa',
          //   icon: 'archive-outline',
          //   link: '/pages/clients/clients-temporary-portofolio',
          //   hidden: !user?.actions?.some(
          //     (action) => action.action_id == AsconActions.UserPortofolio
          //   )
          // },
          {
            title: 'Simulator Portofoliu',
            icon: 'archive-outline',
            link: '/pages/clients/portofolio-simulator',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.UserPortofolio
            )
          },
          {
            title: 'SETARI',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewDocumentGenerator ||
                action.action_id == AsconActions.ViewTasks ||
                action.action_id == AsconActions.ViewTemplates ||
                action.action_id == AsconActions.ViewFgoImport ||
                action.action_id == AsconActions.ViewPayTypes ||
                action.action_id == AsconActions.ViewWorkProcedures ||
                action.action_id == AsconActions.EditWorkProcedures ||
                action.action_id == AsconActions.GenerateAnafToken
            )
          },
           {
            title: 'Abonamente clienti',
            icon: 'people-outline',
            link: '/pages/client-plans/client-plans',
            hidden: !user?.actions?.some((action) => action.action_id == AsconActions.ViewClientPlans)
          },
          {
            title: 'Token ANAF',
            icon: 'people-outline',
            link: '/pages/anaf/generate-anaf-token',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.GenerateAnafToken
            )
          },
          {
            title: 'Generator documente',
            icon: 'file-add-outline',
            link: '/pages/document-generator/view-documents',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewDocumentGenerator
            )
          },
          {
            title: 'Regiuni IBAN',
            icon: 'globe-2-outline',
            link: '/pages/iban-regions/iban-regions',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewIbanRegions
            )
          },
          {
            title: 'Generator documente Drive',
            icon: 'file-add-outline',
            link: '/pages/document-generator/view-document-templates',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewDocumentGenerator
            )
          },
          {
            title: 'Taskuri fise de lucru',
            icon: 'folder-outline',
            link: '/pages/worksheets/view-tasks',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewTasks
            ),
          },
          {
            title: 'Template-uri fise de lucru',
            icon: 'credit-card-outline',
            link: '/pages/worksheets/view-templates',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewTemplates
            )
          },
          {
            title: 'FGO import',
            icon: 'file-text-outline',
            link: '/pages/fgo-incomes/view-fgo-incomes',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewFgoImport
            )
          },
          {
            title: 'Categorii plati',
            icon: 'menu-outline',
            link: '/pages/payments/view-incomes-categories',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewPayTypes
            ),
          },
          {
            title: 'Categorii incasari',
            icon: 'menu-outline',
            link: '/pages/incomes2/view-incomes-categories',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewIncomeTypes
            )
          },
          {
            title: 'Proceduri de lucru',
            icon: 'menu-outline',
            link: '/pages/worksheets/view-work-procedures',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewWorkProcedures
            )
          },
          {
            title: 'UTILITAR',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewSagaDbFileConvertor ||
                action.action_id == AsconActions.ViewBringoUtil ||
                action.action_id == AsconActions.ViewCovidClients ||
                action.action_id == AsconActions.ViewConvertorBtPaymentsUtil
            )
          },
          {
            title: 'Saga DBFile convertor',
            icon: 'file-text-outline',
            link: '/pages/saga-dbfile/view-saga-dbfile',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewSagaDbFileConvertor
            ),
          },
          {
            title: 'Convertor Bringo',
            icon: 'save-outline',
            link: '/pages/bringo/view-bringo',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewBringoUtil
            )
          },
          {
            title: 'Convertor Plăți BT',
            icon: 'save-outline',
            link: '/pages/convertor-bt-payments/view-convertor-bt-payments',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewConvertorBtPaymentsUtil
            )
          },
          {
            title: 'Import clienti firme.ro',
            icon: 'save-outline',
            link: '/pages/import-clients/view-import-clients',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewImportClientsUtil
            )
          },
          {
            title: 'Masuri sprijin COVID',
            icon: 'alert-triangle-outline',
            link: '/pages/clients/view-clients-per-year',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewCovidClients
            )
          },
          {
            title: 'SERVICII',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewInstitutionIssues ||
                action.action_id == AsconActions.ViewOrcs
            )
          },
          {
            title: 'Probleme institutii',
            icon: 'alert-triangle-outline',
            link: '/pages/institution-issues/view-institution-issues',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewInstitutionIssues
            )
          },
          {
            title: 'ORC',
            icon: 'inbox-outline',
            link: '/pages/orcs/view-orcs',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewOrcs
            )
          },
          {
            title: 'Fonduri europene',
            icon: 'briefcase-outline',
            link: '/pages/european-fonds/european-fonds',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewEuropeanFonds
            )
          },
          {
            title: 'FMIU',
            group: true,
            hidden: !user?.actions?.some(
              (action) =>
                action.action_id == AsconActions.ViewInstitutionIssues ||
                action.action_id == AsconActions.ViewOrcs
            )
          },
          {
            title: 'FMIU Registru incasari plati',
            icon: 'shopping-cart-outline',
            link: '/pages/fmiu/view-incomes-payments',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewFmiuPayments
            )
          },
          {
            title: 'FMIU Categorii plati',
            icon: 'menu-outline',
            link: '/pages/fmiu/view-fmiu-payments-categories',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewFmiuPaymentCategories
            )
          },
          {
            title: 'FMIU Categorii incasari',
            icon: 'menu-outline',
            link: '/pages/fmiu/view-fmiu-incomes-categories',
            hidden: !user?.actions?.some(
              (action) => action.action_id == AsconActions.ViewFmiuIncomesCategories
            )
          },
          {
            title: '',
            group: true
          },
          {
            title: '',
            group: true
          }
        ];
        this.menu = this.originalMenu;
      });
  }

  onInput() {
    this.menu = this.originalMenu.filter(
      (item) => item.title.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
    );
  }
}
